/**
 *
 * Lưu 1 record setting trong index setting
 * hiện tại mới chỉ dùng cho chia hội thoại
 */
import {IPageSetting} from '@core/models';

export interface ISetting {
  id: string,
  type: number,
  businessId: number,
  pageIds: number[] | string[],
  createAt: number,
  createById: string,
  lastUpdatedAt: string,
  status: number,
  userIds: number[] | string[],
  name: string,
  content: ISettingSplit | ISplitConfigGroup | ISplitConfigIndividual | ISplitConfigManual | ISplitConfigShift | ISettingGroup,
}

/**
 *
 * Lưu cài đặt chung của chia hội thoại
 * type: DivisionConversationConst.TYPE_CONVERSATION_SPLIT
 */
export interface ISettingSplit {
  mode: number, // chế độ chia theo: cá nhân, nhóm, thủ công, ca
  ignorePostIds: number[] | string[], // không chia bình luận đến từ bài viết
}

export interface ISettingGroup {
  configs: {
    ratio: number, // tỉ lệ
    order: number, // thứ tự
    leaderIds?: Array<string | number>, // trưởng nhóm
    users?: {
      id: string | number,
      ratio: number,
    }[],
  }
}

/**
 * Lưu cài đặt 1 cấu hình của chia hội thoại theo nhóm
 * type: DivisionConversationConst.TYPE_CONVERSATION_SPLIT_GROUP
 */
export interface ISplitConfigGroup {
  configs: {
    pageIds: string[] | number[], // Cài đặt cho các pages
    groupIds: string[],
    name: string, // tên cấu hình
    status: number,
  }[],
  groupAssignType: number, // mặc định TYPE_GROUP_ASSIGN_DEFAULT
  showAll: number, // cho phép nhân viên không nằm trong danh sách chia được xem tất cả hội thoại
  viewUnassignedPage: number, // Cho phép nhân viên xem hội thoại của các page không nằm trong cấu hình nào.
}

export interface ISplitGroupConfig {
  pageIds: Array<string | number>;
  groupIds: string[];
  name: string;
  status: number;
}

export interface ISplitGroupSetting {
  type: number;
  status: number;
  name: string;
  pageIds: Array<string | number>;
  userIds: Array<string | number>;
  content: {
    configs: ISplitGroupConfig[];
    showAll: number;
    viewUnassignedPage: number;
    groupAssignType: number;
  };
}

export interface ISplitGroupItem {
  id?: string;
  businessId?: number;
  type: number;
  status: number;
  name: string;
  userIds: Array<string | number>;
  pageIds: Array<string | number>;
  content: {
    configs: {
      ratio: number | string;
      order: number;
      leaderIds: Array<string | number>;
      users: { id: string | number; ratio: number | string }[];
    };
  };
  percent?: number | null;
  isNew?: boolean;
  isActive?: boolean;
}

export interface ISplitStaffInGroup {
  id: string | number;
  name: string;
  avatar: string;
  checked: number;
  ratio: number | string;
  percent: number | null;
  isLeader: boolean;
}

export interface ISplitGroupDeleteItem {
  id: string;
  status: number;
  afterDelete: number;
  businessId: number;
  fanpageIds: Array<string | number>;
}

/**
 * Lưu cài đặt 1 cấu hình của chia hội thoại theo cá nhân
 * type: DivisionConversationConst.TYPE_CONVERSATION_SPLIT_INDIVIDUAL
 */
export interface ISplitConfigIndividual {
  configs: {
    pageIds: string[] | number[], // Cài đặt cho các pages
    users: {
      id: string, // id nhân viên
      ratio: { // tỉ lệ
        inbox: number, // tin nhắn
        comment: number // bình luận
      },
      order: number, // thứ tự
    }[],
    name: string, // tên cấu hình
    status: number,
  }[],
  exceed: { // nv có số hội thoại vượt quá
    type: number, // chưa đọc/trả lời: TYPE_CONVERSATION_SPLIT_EXCEED_UNLIMITED| TYPE_CONVERSATION_SPLIT_EXCEED_UNREAD | TYPE_CONVERSATION_SPLIT_EXCEED_REPLY
    number: number, // sl
  },
  absent: number, // k chia cho nhân viên vắng mặt sau x'
  absentUnit: number, // đơn vị phứt | giờ
  reassignAfter: number, // chia thêm nv khác xử lý sau x'
  reassignAfterUnit: number, // đơn vị phứt | giờ
  reassignType: number, // chưa đọc/trả lời: tự động chia lại TYPE_CONVERSATION_SPLIT_REASSIGN_NO_READ | TYPE_CONVERSATION_SPLIT_REASSIGN_NO_REPLY
  showAll: number, // cho phép nhân viên không nằm trong danh sách chia được xem tất cả hội thoại
  viewUnassignedPage: number, // Cho phép nhân viên xem hội thoại của các page không nằm trong cấu hình nào.
  evenlyOffline: number, // Chia đều hội thoại khi không có nhân viên nào online.
}

/**
 * Lưu cài đặt 1 cấu hình của chia hội thoại thủ công
 * type: DivisionConversationConst.TYPE_CONVERSATION_SPLIT_MANUAL
 */
export interface ISplitConfigManual {
  configs: {
    pageIds: string[] | number[], // Cài đặt cho các pages
    userIds: number[] | string[],
    name: string, // tên cấu hình
    status: number,
  }[],
  splitWaiting: number, // Tự động chuyển hội thoại về danh sách chờ Chia nếu nhân viên không trả lời sau x'
  splitWaitingUnit: number, // đơn vị phứt | giờ
}

export interface ISplitManualConfig {
  pageIds: Array<string | number>;
  userIds: Array<string | number>;
  name: string;
  status: number;
}

export interface ISplitManualSetting {
  type: number;
  status: number;
  name: string;
  pageIds: Array<string | number>;
  userIds: Array<string | number>;
  content: {
    configs: ISplitManualConfig[];
    splitWaiting: number;
    splitWaitingUnit: number;
  };
}

export interface ISplitManualStaffInConfig {
  id: string | number;
  name: string;
  avatar: string;
  checked: number;
}

/**
 * Lưu cài đặt 1 cấu hình của chia hội thoại theo ca
 * type: DivisionConversationConst.TYPE_CONVERSATION_SPLIT_SHIFT
 */
export interface ISplitConfigShift {
  pageIds: string[] | number[], // Cài đặt cho các pages
  shifts: {
    [day: number]: // thứ trong tuần lưu 2->8 như setting cũ
      { // 1 ca làm việc
        name: string, // tên ca
        time: string, // thời gian 1 ca
        users: string[] // user id trong 1 ca
      }[],
  }[],
  showAll: number, // cho phép nhân viên không nằm trong danh sách chia được xem tất cả hội thoại
}

export interface IGetPageSettingResponse {
  setting: IPageSetting;
  channel: number;
}

export interface IUpdatePageSettingParams {
  id: string;
  setting: string;
}

/** BE POST /chat/pagesetting returns { settings: IPageSetting } (plural) */
export interface IUpdatePageSettingResponse {
  settings: IPageSetting;
}

export interface IGetSplitSettingParams {
  act: 'setting' | 'setting2';
  businessId: string | number;
  type?: number;
}

export interface IUpdateSplitSettingParams extends IGetSplitSettingParams {
  setting: string;
  stepLog?: number;
  subTypeLog?: number;
}

export interface IDeleteSplitSettingParams {
  id: string;
  businessId: string | number;
}

export interface IGetSplitSettingListParams {
  businessId?: string | number;
  businessIds?: Array<string | number>;
  types: number[];
  typeSetting?: string;
  groupIds?: string[];
  channel?: number;
  fields?: string[];
}

/** POST /business/setting/replaceusersettingshift */
export interface IReplaceUserSettingShiftParams {
  businessId: string | number;
  userIds: Array<string | number>;
  shiftIds?: string[];
  isRemoveUser?: 0 | 1; // 1: gỡ nhân viên khỏi mọi ca (khi shiftIds rỗng)
}

/** POST /setting/split/checkgroupassigned */
export interface ICheckGroupAssignedParams {
  businessId: string | number;
  fanpageId: Array<string | number>;
  groupId: string;
}

export interface ICheckGroupAssignedResponse {
  next?: unknown[];
  totalItems?: number;
  result: Array<{ id: string } & Record<string, unknown>>;
}

/** POST /setting/split/statusstaffactive */
export interface IStatusStaffActiveParams {
  businessId: string | number;
  ids: Array<string | number>;
}

export interface IStaffActiveStatus {
  displayName?: string | null;
  fbName?: string | null;
  fbUid?: string | null;
  lastActiveAt?: number | null;
  joinConversationAt?: number | null;
  active: number; // 1: hoạt động trong 1 phút gần nhất
  joined?: number;
}

export interface IStatusStaffActiveResponse {
  // map theo uId; không có user nào -> []
  result: Record<string, IStaffActiveStatus> | [];
}

export interface ISplitGroupsParams {
  act: 'list' | 'delete';
  businessId: string | number;
  type?: number;
  ids?: string[];
  groupIds?: ({ id: string } & Record<string, any>)[];
}

export interface ISplitSettingResponse {
  id?: string;
  businessId?: number;
  type?: number;
  status?: number;
  name?: string | null;
  pageIds?: Array<string | number>;
  userIds?: Array<string | number>;
  content?: any;
  createdAt?: number | null;
  lastUpdatedAt?: number | null;
  dataDivision?: any;
}

export interface IUpdateSplitSettingResponse {
  item?: ISplitSettingResponse | ISplitSettingResponse[];
  result?: ISplitSettingResponse[];
  removeUserIds?: { userId: number; pageIds: Array<string | number> }[];
}

/**
 * Mot user can check truoc khi xoa khoi cau hinh chia hoi thoai.
 * pageIds la danh sach page dang cau hinh cho user do trong config hien tai.
 */
export interface ICheckUserAssignedItem {
  userId: string | number;
  pageIds: Array<string | number>;
}

/**
 * Params POST /setting/user/checkuserassigned.
 * BE yeu cau removeUserIds la JSON string cua mang ICheckUserAssignedItem.
 */
export interface ICheckUserAssignedParams {
  removeUserIds: string;
}

/**
 * Data response cua /setting/user/checkuserassigned.
 * reUserIds chi gom cac user van con duoc gan it nhat 1 hoi thoai trong 2 ngay gan nhat.
 * number la tong so hoi thoai dang duoc gan cho user can xoa.
 */
export interface ICheckUserAssignedResponse {
  reUserIds?: ICheckUserAssignedItem[];
  number?: number;
}

/**
 * Params POST /chat/getpostsindb.
 * - Mode danh sach: truyen fanpageIds de lay bai viet cua nhieu page, hoac fanpageId de lay 1 page.
 * - Mode tim theo link: truyen postUrl va bat buoc co fanpageId cua page chua bai viet.
 * - next la cursor data.next API tra ve, dung nguyen gia tri do cho lan load tiep theo.
 */
export interface IGetPostsInDbParams {
  fanpageId?: string | number;
  fanpageIds?: Array<string | number>;
  postUrl?: string;
  postId?: string;
  size?: number;
  next?: any[];
}

/**
 * Mot bai viet tra ve tu /chat/getpostsindb.
 * Field co the thieu tuy du lieu luu trong Elastic, nen khai bao optional theo doc.
 */
export interface IGetPostsInDbItem {
  id: string;
  fanpageId?: string | null;
  message?: string | null;
  story?: string | null;
  attachments?: any[] | Record<string, any> | null;
  permalink?: string | null;
  url?: string | null;
  createdTime?: number | null;
  isLive?: number | null;
  isReels?: number | null;
}

/**
 * Data paginator cua /chat/getpostsindb.
 * result la danh sach bai viet, next la cursor scroll tiep theo, totalItems co the bang 0 neu BE khong dem.
 */
export interface IGetPostsInDbResponse {
  result: IGetPostsInDbItem[];
  next: any[];
  totalItems: number;
}

export const DivisionConversationConst = {
  STATUS_ACTIVE: 1,
  STATUS_INACTIVE: 2,

  /**
   * define 4 const cho setting chia hội thoại
   * + TYPE_CONVERSATION_SPLIT: lưu các setting chung bật/tắt, chế độ chia áp dụng, bỏ qua bài viết, cho phép nhân viên xem
   * + 4 const:
   * TYPE_CONVERSATION_SPLIT_GROUP,TYPE_CONVERSATION_SPLIT_INDIVIDUAL,
   * TYPE_CONVERSATION_SPLIT_MANUAL,TYPE_CONVERSATION_SPLIT_SHIFT
   * lưu chi tiết setting của từng chế độ chia
   *
   */
  TYPE_CONVERSATION_SPLIT: 1, // type lưu setting chia hội thoại chung
  TYPE_CONVERSATION_SPLIT_MODE_GROUP: 2, // chia theo nhóm
  TYPE_CONVERSATION_SPLIT_MODE_INDIVIDUAL: 3, // chia theo cá nhân
  TYPE_CONVERSATION_SPLIT_MODE_MANUAL: 4, // chia thủ công
  TYPE_CONVERSATION_SPLIT_MODE_SHIFT: 5, // chia theo ca
  TYPE_CONVERSATION_SPLIT_GROUP: 6, // danh sach group
  TYPE_SHIFT_MONDAY: 12,
  TYPE_SHIFT_TUESDAY: 13,
  TYPE_SHIFT_WESNEDDAY: 14,
  TYPE_SHIFT_THURSDAY: 15,
  TYPE_SHIFT_FRIDAY: 16,
  TYPE_SHIFT_SATURDAY: 17,
  TYPE_SHIFT_SUNDAY: 18,
  TYPE_ECOM_ORDER_CUSTOMER_CARE: 7, // cài đặt chăm sóc đơn hàng cho sàn
  TYPE_ECOM_AUTO_REPLY_REVIEW: 8, // cài đặt tự động trả lời đánh giá cho sàn

  // ưu tiên chia
  TYPE_CONVERSATION_SPLIT_PRIORITY_ALL: 1,
  TYPE_CONVERSATION_SPLIT_PRIORITY_ONLINE: 2,
  TYPE_CONVERSATION_SPLIT_PRIORITY_ONLY_ONLINE: 3,

  // hội thoại vượt quá | không giới hạn
  TYPE_CONVERSATION_SPLIT_EXCEED_UNLIMITED: 0,
  TYPE_CONVERSATION_SPLIT_EXCEED_UNREAD: 1,
  TYPE_CONVERSATION_SPLIT_EXCEED_REPLY: 2,

  // Chuyển hội thoại cho nhân viên khác nếu hội thoại chưa
  TYPE_CONVERSATION_SPLIT_REASSIGN_NO_READ: 1,
  TYPE_CONVERSATION_SPLIT_REASSIGN_NO_REPLY: 2,

  // xử lý các hội thoại đã gắn sau khi xóa nhóm/nv
  TYPE_AFTER_DELETE_WAIT_LIST: 1, // đưa vào danh sách chờ chia
  TYPE_AFTER_DELETE_SPLIT_NOW: 2, // chia lại luôn
  TYPE_AFTER_DELETE_NONE: 3, // không làm gì, giữ nguyên

  TYPE_GROUP_ASSIGN_DEFAULT: 1, // nhân viên trong nhóm đều xem chung
  TYPE_GROUP_ASSIGN_AUTO: 2, // tự động chia cho nhân viên trong nhóm theo tỉ lệ
  TYPE_GROUP_ASSIGN_MANUAL: 3, // không tự động chia, trưởng nhóm chia thủ công

  getSplitName: (mode: number): string => typeof SPLIT_MODE_NAME[mode] != 'undefined' ? SPLIT_MODE_NAME[mode] : '',
}

export const SPLIT_MODE_NAME = {
  [DivisionConversationConst.TYPE_CONVERSATION_SPLIT_MODE_GROUP]: 'Chia theo nhóm',
  [DivisionConversationConst.TYPE_CONVERSATION_SPLIT_MODE_INDIVIDUAL]: 'Chia theo cá nhân',
  [DivisionConversationConst.TYPE_CONVERSATION_SPLIT_MODE_MANUAL]: 'Chia thủ công',
  [DivisionConversationConst.TYPE_CONVERSATION_SPLIT_MODE_SHIFT]: 'Chia theo ca',
}

export const SPLIT_SHIFT_TYPES = [
  DivisionConversationConst.TYPE_SHIFT_MONDAY,
  DivisionConversationConst.TYPE_SHIFT_TUESDAY,
  DivisionConversationConst.TYPE_SHIFT_WESNEDDAY,
  DivisionConversationConst.TYPE_SHIFT_THURSDAY,
  DivisionConversationConst.TYPE_SHIFT_FRIDAY,
  DivisionConversationConst.TYPE_SHIFT_SATURDAY,
  DivisionConversationConst.TYPE_SHIFT_SUNDAY,
];

export interface ISplitShiftItem extends ISplitSettingResponse {
  id: string;
  type: number;
  content: {
    name?: string;
    ranges?: {
      from?: { h?: string | number; m?: string | number };
      to?: { h?: string | number; m?: string | number };
    };
  };
  userIds: Array<string | number>;
  createdAt?: number | null;
}
